import Component from '../../common/Component';
import listItems from '../../common/helpers/listItems';
export default class HeaderListGroup extends Component {
  view(vnode) {
    return m("div", {
      className: "HeaderListGroup"
    }, m("div", {
      className: "HeaderListGroup-header"
    }, vnode.attrs.label), m("ul", {
      className: "HeaderListGroup-content"
    }, listItems(vnode.children)));
  }
}
flarum.reg.add('core', 'forum/components/HeaderListGroup', HeaderListGroup);